/* unplugin-vue-components disabled */import script from "./StageGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./StageGenerator.vue?vue&type=script&setup=true&lang=js"

import "./StageGenerator.vue?vue&type=style&index=0&id=62708e0e&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62708e0e"]])

export default __exports__